export default ['Penalty', 'Warning', 'Others']
